import { MoveRightIcon } from 'lucide-react'

import type { StatusChange } from '@/pages/control/risk-questionnaire-thread-card/types'

import { ControlStatusBadge } from '@/components/shared/control-status-badge/control-status-badge'

type StatusChangeBadgesProps = {
  change: StatusChange
}

export const StatusChangeBadges = ({ change }: StatusChangeBadgesProps) => (
  <div className='flex items-center gap-1'>
    <ControlStatusBadge status={change.from} variant='outline' />
    <MoveRightIcon className='size-5 shrink-0 text-main-foreground-placeholder' aria-hidden />
    <ControlStatusBadge status={change.to} variant='outline' />
  </div>
)
